import { createGetterForHostApp } from 'mini-opx-utils/lib/createGetterForHostApp';
import { EndpointType } from '../schema/EndpointType';
import {
    IOS_OUTLOOK,
    ANDROID_OUTLOOK,
    ANDROID_OUTLOOK_LITE,
    TEAMS,
    TEAMS_HUB,
    ANDROID_TEAMS,
    IOS_TEAMS,
} from 'owa-config';

import type { MiniHostApps } from 'mini-opx-config/lib/types/MiniHostApps';

const HOSTNAME_ENDPOINT_TYPE_MAPPING = new Map<MiniHostApps, EndpointType>([
    [ANDROID_OUTLOOK_LITE, EndpointType.OutlookLite],
    [ANDROID_OUTLOOK, EndpointType.NotSupported],
    [IOS_OUTLOOK, EndpointType.NotSupported],
    [TEAMS, EndpointType.NotSupported],
    [TEAMS_HUB, EndpointType.NotSupported],
    [ANDROID_TEAMS, EndpointType.NotSupported],
    [IOS_TEAMS, EndpointType.NotSupported],
]);

/**
 * This function returns the type of endpoint(mini, extension, outlook Lite, etc) where code is running.
 * @returns
 */
export const getEndpointType = createGetterForHostApp(
    HOSTNAME_ENDPOINT_TYPE_MAPPING,
    EndpointType.MiniOwa
);
